import React, { useState } from "react";
import "./experience.css";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react/dist/iconify.js";

const spokes = [
  {
    finalNumber: 6,
    title: "Years in Web Development",
    icon: "mdi:calendar-check",
  },
  {
    finalNumber: 120,
    title: "Projects Contributed To",
    icon: "mdi:rocket-launch",
  },
  {
    finalNumber: 20,
    title: "AI Features & Tools",
    icon: "mdi:robot-outline",
  },
  {
    finalNumber: 12,
    title: "Years in Operations, Logistics & Supply Chain",
    icon: "mdi:truck-outline",
  },
];

const SpokeItem = ({ finalNumber, title, icon, index }) => {
  const [number, setNumber] = useState(0);
  const [hasCounted, setHasCounted] = useState(false);

  const startCounting = () => {
    if (hasCounted) return;
    setHasCounted(true);

    let start = 0;
    const totalDuration = 1200;
    const incrementTime = Math.max(6, Math.floor(totalDuration / finalNumber));

    const timer = setInterval(() => {
      start += 1;
      setNumber(start);
      if (start >= finalNumber) clearInterval(timer);
    }, incrementTime);
  };

  return (
    <motion.div
      className="spoke-item"
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: 0.6, type: "spring", delay: index * 0.1 }}
      onViewportEnter={startCounting}
    >
      <div className="spoke-node">
        <Icon icon={icon} className="spoke-icon" />
        <span className="spoke-badge">{number}+</span>
      </div>
      <div className="spoke-content">
        <h3 className="spoke-title">{title}</h3>
      </div>
    </motion.div>
  );
};

const Experience = () => {
  return (
    <div className="experience-wrapper">
      <motion.h2
        className="experience-eyebrow"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.6 }}
        transition={{ duration: 0.6, type: "spring" }}
      >
        Track Record
      </motion.h2>

      <div className="experience">
        <div className="experience-diagram">
          <motion.div
            className="experience-hub"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.7, type: "spring" }}
          >
            <div className="experience-hub-ring">
              <Icon icon="mdi:trending-up" className="experience-hub-icon" />
            </div>
            <span className="experience-hub-label">
              6+ Years
              <br />
              Building for the Web
            </span>
          </motion.div>

          <div className="experience-spokes">
            {spokes.map((spoke, index) => (
              <SpokeItem key={spoke.title} {...spoke} index={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
